var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRalvieIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 135,
    height: 150,
    viewBox: "0 0 135 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 0.977,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa9c2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.587,
    stopColor: "#814d55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d0b77"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_105",
    "data-name": "Subtraction 105",
    d: "M67.5,150h-.568l-.011,0H67.9C67.77,150,67.634,150,67.5,150Zm-5.348-.2h0a68.875,68.875,0,0,1-24.383-6.428A68.155,68.155,0,0,1,27.2,137.15a67.24,67.24,0,0,1-9.169-7.924,65.836,65.836,0,0,1-7.539-9.4,64.1,64.1,0,0,1-5.673-10.656A62.9,62.9,0,0,1,5.174,60H46.732c8.589,0,15.577,6.729,15.577,15S55.322,90,46.732,90H16.986l9.585,12.694L32.091,110l30.062,39.8Zm19.792-1.289h0L52.528,109.56a37.19,37.19,0,0,0,8.348-2.314,36.128,36.128,0,0,0,11.552-7.5,34.758,34.758,0,0,0,7.79-11.122,33.926,33.926,0,0,0,0-27.247,34.811,34.811,0,0,0-7.79-11.124,36.246,36.246,0,0,0-11.552-7.5A37.294,37.294,0,0,0,46.732,40H18.79a67.328,67.328,0,0,1,10.1-8.327,68.114,68.114,0,0,1,11.681-6.3,68.854,68.854,0,0,1,12.968-3.986A70.687,70.687,0,0,1,81.1,21.32a69.05,69.05,0,0,1,12.67,3.787A68.219,68.219,0,0,1,105.239,31.1a67.376,67.376,0,0,1,9.99,7.938,66,66,0,0,1,8.243,9.62A64.15,64.15,0,0,1,129.7,59.7a63,63,0,0,1,1.28,47.458,64.15,64.15,0,0,1-11.126,18.879,66.983,66.983,0,0,1-16.817,14.238,68.452,68.452,0,0,1-21.088,8.234ZM75.287,15H59.71A7.888,7.888,0,0,1,54.2,12.8,7.306,7.306,0,0,1,54.2,2.2,7.891,7.891,0,0,1,59.71,0H75.287A7.892,7.892,0,0,1,80.8,2.2a7.306,7.306,0,0,1,0,10.607A7.887,7.887,0,0,1,75.287,15Z",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRalvieIcon);
export default __webpack_public_path__ + "static/media/ralvieIcon.12f873ad5b1ae57d2a54e244f826cce6.svg";
export { ForwardRef as ReactComponent };